module.exports = __webpack_public_path__ + "static/media/youth.63832124.jpg";